import React from 'react';
import { Switch, Box, Tooltip, IconButton } from '@mui/material';
import { Delete, Cancel, MarkEmailRead } from '@mui/icons-material';
import { toast } from 'react-toastify';

const EmailStatusSwitch = ({ isVerified, onDelete, fetchData, rowId }) => {
  const handleChange = async () => {
    try {
      // Toggle verification status
      const newStatus = !isVerified;
      console.log('New Verification Status:', newStatus);
      
      // Update the verification status in the database
      const response = await fetch('/api/v1/verify-email-bydebounce/', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ records: [{ status: newStatus, id: rowId }] }),
      });
      
      if (!response.ok) {
        //throw new Error(`Failed to update status: ${response.statusText}`);
toast.error(`Failed to update status: ${response.statusText}`);
      }
      
      console.log('Verification status updated successfully');
      toast.success(`Email ${newStatus ? 'verified' : 'unverified'} successfully!`);
      fetchData(); // Refresh data after update
    } catch (error) {
      console.error('Error updating verification status:', error);
      toast.error(`Error updating status: ${error.message}`);
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {/* Tooltip for better UX */}
      <Tooltip title={isVerified ? 'Verified' : 'Not Verified'}>
        <Switch
          checked={isVerified}
          onChange={handleChange}
          color="success"
        />
      </Tooltip>

      {/* Status Display with Email Check Icon if Verified */}
      {isVerified ? (
        <MarkEmailRead color="success" />
      ) : (
        <Cancel color="error" />
      )}

      {/* Delete Button with Confirmation */}
      {!isVerified && (
        <Tooltip title="Delete Record">
          <IconButton color="error" onClick={onDelete}>
            <Delete />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default EmailStatusSwitch;
